import { Environment } from "./config";

export const Config = {
  ENVIRONMENT() {
    return getEnvVar("ENVIRONMENT", "local");
  },
  MICROSOFT_APP_ID() {
    return getEnvVar("MICROSOFT_APP_ID");
  },

  MICROSOFT_APP_PASSWORD() {
    return getEnvVar("MICROSOFT_APP_PASSWORD");
  },

  CONNECTION_NAME() {
    return getEnvVar("CONNECTION_NAME");
  },

  DOMAIN() {
    return getEnvVar("DOMAIN");
  },

  SUCCESS_IMAGE() {
    return getEnvVar("SUCCESS_IMAGE");
  },

  WELCOME_IMAGE() {
    return getEnvVar("WELCOME_IMAGE");
  },
  GET_AUTH_URL() {
    return getEnvVar("AUTH_SERVICE_URL");
  },
  GET_EMAIL_URL() {
    return getEnvVar("EMAIL_FETCH_URL");
  },
  GET_REDIS_URL() {
    return getEnvVar("REDIS_URL");
  }
};
const getEnvVar = (name, defaultValue = "") => {
  const environment = process.env["BIW_ENVIRONMENT"] || "local";
    // console.log( environment );
  const result =
    // priority 1 is get the value from the config
    Environment[environment][name] ||
    // priority 2 is get the value from the system
    process.env["BIW_" + name] ||
    // priority 3 is to get the value from npm
    process.env[`npm_package_config_${name.toLowerCase()}`] ||
    // default
    defaultValue;
  return result;
};
